import { render, staticRenderFns } from "./oembed_video.vue?vue&type=template&id=305e3404&"
import script from "./oembed_video.vue?vue&type=script&lang=js&"
export * from "./oembed_video.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports